import React from "react";

export default function CandleStickIcon() {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_500_3836)">
        <path
          d="M2.5 13V11.5H1V2.5H2.5V1H4V2.5H5.5V11.5H4V13H2.5ZM2.5 10H4V4H2.5V10ZM8.5 13V9.25H7V4H8.5V1H10V4H11.5V9.25H10V13H8.5ZM8.5 7.75H10V5.5H8.5V7.75Z"
          fill="#FC4C4C"
        />
      </g>
      <defs>
        <clipPath id="clip0_500_3836">
          <rect width="12" height="12" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
